import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
@Component({
  selector: 'app-admin-utility-report-modal',
  templateUrl: './admin-utility-report-modal.component.html',
  styleUrls: ['./admin-utility-report-modal.component.css'],
})
export class AdminUtilityReportModalComponent implements OnInit {
  utilityReportForm = this.fb.group({
    currentStatus: [, Validators.required],
    status: [, Validators.required],
    customerID: [, Validators.required],
    brand: [, Validators.required],
    tdsp: [, Validators.required],
    profileCreationDate: [, Validators.required],
    utilityName: [, Validators.required],
    signupDate: [, Validators.required],
    signupTime: [, Validators.required],
    firstName: [, Validators.required],
    lastName: [, Validators.required],
    emailAddress: [, Validators.required],
    homePhone: [, Validators.required],
    mobilePhone: [, Validators.required],
    workPhone: [, Validators.required],
    authorizedRepresentative: [, Validators.required],
    eSIID: [, Validators.required],
    serviceAddress1: [, Validators.required],
    serviceAddress2: [, Validators.required],
    serviceCity: [, Validators.required],
    serviceState: [, Validators.required],
    serviceZipCode: [, Validators.required],
    billingAddress1: [, Validators.required],
    billingAddress2: [, Validators.required],
    billingCity: [, Validators.required],
    billingState: [, Validators.required],
    billingZipCode: [, Validators.required],
    serviceType: [, Validators.required],
    requestedStartDate: [, Validators.required],
    endDate: [, Validators.required],
    energyRate: [, Validators.required],
    avgUsage: [, Validators.required],
    term: [, Validators.required],
    planName: [, Validators.required],
    renewableContent: [, Validators.required],
    enrollmentSource: [, Validators.required],
    promoCode: [, Validators.required],
  });
  fromPage: any;
  fromDialog: string;
  action: any;
  itemData: any;

  constructor(
    private fb: FormBuilder,
    private residentialService: ResidentialService, // public dialogRef: MatDialogRef<EnergyProvidersModalComponent>, // @Inject(MAT_DIALOG_DATA) public data: DialogData,

    public dialogRef: MatDialogRef<AdminUtilityReportModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.fromPage = data.pageValue;
    this.action = data.action;
    this.itemData = data.itemData;
  }

  ngOnInit() {
    console.log('parent', this.fromPage);
    if (this.action == 'Update') {
      const postobj = this.setModulesInfo();
      this.utilityReportForm.patchValue({
        // {ModuleID: "1", ModuleName: "ACH Credit FY"}
        promoCode: this.itemData['PromoCode'],
        providerCloudLogo: this.itemData['ProviderCloudLogo'],
        providerEmail: this.itemData['ProviderEmail'],
        providerName: this.itemData['ProviderName'],
        providerOperationHours: this.itemData['ProviderOperationHours'],
        providerPhone: this.itemData['ProviderPhone'],
        recipientEmail: this.itemData['RecipientEmail'],
        status: this.itemData['Status'],
        utilityContact: this.itemData['UtilityContact'],
        utilityName: this.itemData['UtilityName'],
      });
    }
  }
  setModulesInfo() {
    let promoCode = this.utilityReportForm.get('promoCode').value;
    let providerEmail = this.utilityReportForm.get('providerEmail').value;
    let providerName = this.utilityReportForm.get('providerName').value;
    // let providerOperationHours = this.utilityReportForm.get(
    //   'providerOperationHours'
    // ).value;
    let providerPhone = this.utilityReportForm.get('providerPhone').value;
    let utilityName = this.utilityReportForm.get('utilityName').value;
    let recipientEmail = this.utilityReportForm.get('recipientEmail').value;
    let status = this.utilityReportForm.get('status').value;
    let utilityContact = this.utilityReportForm.get('utilityContact').value;
    let postobj = {
      PromoCode: promoCode,
      // ProviderAPIURL: string;
      ProviderEmail: providerEmail,
      // ProviderLogo: providerCloudLogo;
      // ProviderCloudLogo: providerCloudLogo,
      ProviderName: providerName,
      // ProviderOperationHours: providerOperationHours,
      ProviderPhone: providerPhone,
      // ProviderURL: string;
      // Provider_duns: string;
      Status: status,
      UtilityContact: utilityContact,
      UtilityName: utilityName,
      // Environment: string;
      RecipientEmail: recipientEmail,
    };
    return postobj;
  }
  postDataOfNewEnergyProvider() {
    const postobj = this.setModulesInfo();
    if (this.action == 'Update') {
      this.updateProvider(postobj);
    } else {
      this.createProvider(postobj);
    }
  }
  createProvider(postobj) {
    this.residentialService
      .postDataOfNewEnergyProvider(postobj)
      .subscribe((response: any) => {
        console.log('postreports', response);
        // this.fromPage = [...this.fromPage];
        this.dialogRef.close({ event: this.action, data: this.fromPage });
      });
  }
  updateProvider(postobj) {
    let rowIndex = this.fromPage.findIndex(
      (element) =>
        element['ProviderName'] == this.itemData['ProviderName'] &&
        element['UtilityName'] == this.itemData['UtilityName']
    );
    this.residentialService
      .postDataOfNewEnergyProvider(postobj)
      .subscribe((response: any) => {
        console.log('postreports', response);
        if (rowIndex) {
          this.fromPage[rowIndex] = JSON.parse(JSON.stringify(postobj));
        }
        // this.fromPage = [...this.fromPage];
        this.dialogRef.close({ event: this.action, data: this.fromPage });
      });
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
}
